"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 22h20V2zm18-2h-3V9.83l3-3z"
}), 'NetworkCellOutlined');